import styled from 'styled-components';

export default styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;
